// Vendor imports
const { createSelector } = require('reselect')
// Shared imports
const { TYPES: modelTypes } = require('shared/model-types')

function createFriendsSearchSelector() {
  return createSelector(
    [
      state => state.shareModal.friends,
      state => state.shareModal.searchText.toLowerCase()
    ],
    (friends, searchText) => {
      return friends.filter(friend => {
        return friendSearchPhrase(friend).indexOf(searchText) > -1
      })
    }
  )
  function friendSearchPhrase(friend) {
    return [
      friend.username,
      friend['display_name']
    ].join(' ').toLowerCase()
  }
}

function createIsFriendsVisibleSelector() {
  const modelSelector = createModelSelector()
  return createSelector(
    [
      state => state.user.loggedIn,
      modelSelector
    ],
    (loggedIn, shareModalModel) => (
      loggedIn &&
      shareModalModel &&
      shareModalModel.type === modelTypes.ARTICLE
    )
  )
}

function createModelSelector() {
  return createSelector(
    state => {
      if (state.shareModal) {
        return state.shareModal.feedItem
      }
    },
    feedItem => feedItem && feedItem.getModel()
  )
}

module.exports = {
  createFriendsSearchSelector,
  createIsFriendsVisibleSelector,
  createModelSelector
}
